import PropTypes from "prop-types";
import { OFFER_CONTRACT_TYPES } from "app/constants";
import "./QuotationRoom.scss";
import RadioFormik from "app/pages/.shared/form/RadioFormik";
import QuotationRoomBody from "./QuotationRoomBody";
import QuotationRoomLabel from "./QuotationRoomLabel";
import classNames from "classnames";

const QuotationRoom = ({
	accommodation = {},
	onChange = () => {},
	contractType,
	stressMarketingLabel,
}) => {
	const rooms = accommodation?.items?.map(
		({
			quantity,
			description,
			label,
			area,
			adults,
			children,
			infants,
			amenities,
			accommodationItemCode,
			photos,
		}) => ({
			id: accommodationItemCode,
			quantity,
			description,
			title: label,
			amenities: amenities?.map(item => item?.label) || [],
			photos: photos || [],
			area: {
				value: area?.value || 0,
				unit: area?.unit || "m²",
			},
			...(contractType !== OFFER_CONTRACT_TYPES.RENTAL && {
				occupancy: { adults, children, babies: infants },
			}),
		})
	);

	const hasDetails = rooms.some(room => {
		const hasPhoto = room?.photos?.length > 0;
		const hasDescription = room?.description?.length > 0;
		const hasAmenities = room?.amenities?.length > 0;

		return hasPhoto || hasDescription || hasAmenities;
	});

	const radioClassName = classNames("quotation-room", {
		"quotation-room--has-details": hasDetails,
	});

	const handleAccommodationChange = event => {
		onChange(accommodation, event);
	};

	return (
		<RadioFormik
			id={accommodation.code}
			showIcon={true}
			name={"accommodation"}
			toggle={handleAccommodationChange}
			value={accommodation.code}
			className={radioClassName}
			data-testid={`quotation-rooms-${accommodation.code}`}
			{...hasDetails && { body: <QuotationRoomBody rooms={rooms} /> }}
		>
			<QuotationRoomLabel
				rooms={rooms}
				price={accommodation.upgradePrice}
				isIncluded={accommodation.included}
				stressMarketingLabel={stressMarketingLabel}
			/>
		</RadioFormik>
	);
};

QuotationRoom.propTypes = {
	accommodation: PropTypes.object,
	onChange: PropTypes.func,
	contractType: PropTypes.oneOf([OFFER_CONTRACT_TYPES.HOTEL, OFFER_CONTRACT_TYPES.RENTAL]),
	stressMarketingLabel: PropTypes.string,
};

export default QuotationRoom;
